import React, { useEffect, useRef, useState } from "react";
import { useLanguage } from "../../context/LanguageContext";

const LANG_LABELS = {
  ar: "العربية",
  en: "English",
  fr: "Français",
};

// Language selector. Order matches the PRD: العربية / English / Français.
const ORDER = ["ar", "en", "fr"];

const LanguageSwitcher = ({ className = "" }) => {
  const { lang, setLang, supported } = useLanguage();
  const langs = ORDER.filter((l) => supported.includes(l));
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Close on outside click / Escape.
  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const select = (l) => {
    setLang(l);
    setOpen(false);
  };

  return (
    <div className={`language-switcher ${className}`.trim()} ref={ref}>
      <button
        type="button"
        className="lang-toggle"
        aria-haspopup="listbox"
        aria-expanded={open}
        lang={lang}
        onClick={() => setOpen((o) => !o)}
      >
        {LANG_LABELS[lang]}
        <span className="lang-caret" aria-hidden="true" />
      </button>

      {open && (
        <ul className="lang-menu" role="listbox">
          {langs.map((l) => (
            <li key={l} role="option" aria-selected={l === lang}>
              <button
                type="button"
                lang={l}
                className={l === lang ? "lang-option active" : "lang-option"}
                onClick={() => select(l)}
              >
                {LANG_LABELS[l]}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;
